import { useLocation } from "react-router-dom";
import { useMemo } from "react";

// URLSearchParams doesn't support IE11 and object/array syntax params

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default useQuery;
